<div class="sharepoint-config-page">
  <div class="gpd-config-section sandbox-card" [class.sandbox-card-gated]="cardState === 'gated'"
    [title]="cardState === 'gated' ? gateTooltip : ''">
    <div>
      <div class="sandbox-title-row">
        <span class="gpd-config-section-title" i18n="@@sandboxFolderLink">Sandbox folder link</span>
        <div class="sandbox-help-wrapper">
          <app-svg-icon icon="help" [size]="16" class="sandbox-help-icon"></app-svg-icon>
          <span class="sandbox-help-tooltip">{{ helpTooltip }}</span>
        </div>
      </div>
      <p class="gpd-config-section-description" i18n="@@sandboxFolderLinkHint">Connect a SharePoint folder as the sandbox for the entire system.</p>
    </div>

    <div class="sandbox-card-body">
      <!-- linked state: current link summary -->
      <div *ngIf="cardState === 'linked'" class="sandbox-linked-block">
        <div class="sandbox-linked-row">
          <app-svg-icon icon="link" [size]="16" class="sandbox-linked-icon"></app-svg-icon>
          <span class="sandbox-linked-url" [title]="currentUrl">{{ currentUrl }}</span>
          <app-gpd-button type="text" icon="copy" [iconSize]="24" [iconStrokeWidth]="1.5" [hint]="hintCopyLink" (onClick)="copyCurrentUrl()"></app-gpd-button>
          <app-gpd-button type="text" icon="delete" iconColor="#dc2626" [iconSize]="24" [iconStrokeWidth]="1.5" [ngClass]="{'gpd-button-text-danger': true}" (onClick)="initRemoveLink()"></app-gpd-button>
        </div>
        <span class="sandbox-linked-date" *ngIf="validatedAt" i18n="@@sandboxValidatedAt">
          Validated: {{ validatedAt | date: 'short' }}
        </span>
      </div>

      <!-- input + validate (empty state, and replace flow in linked state) -->
      <div class="sandbox-input-row" *ngIf="cardState !== 'gated'">
        <dx-text-box
          class="sandbox-url-input"
          [(value)]="urlInput"
          valueChangeEvent="keyup"
          i18n-placeholder="@@sandboxLinkPlaceholder"
          placeholder="https://…sharepoint.com/…"
          [disabled]="isSaving"
          (onValueChanged)="onUrlInputChanged()"
        ></dx-text-box>
        <app-gpd-button type="primary" i18n-text="@@validateLink" text="Validate link"
          [disabled]="validateDisabled" (onClick)="validateLink()"></app-gpd-button>
      </div>

      <!-- gated state: disabled controls -->
      <div class="sandbox-input-row" *ngIf="cardState === 'gated'">
        <dx-text-box class="sandbox-url-input" [disabled]="true"></dx-text-box>
        <app-gpd-button type="primary" i18n-text="@@validateLink" text="Validate link"
          [disabled]="true"></app-gpd-button>
      </div>

      <app-validation-toast #infoToast [inline]="true" [persistent]="true"></app-validation-toast>
    </div>
  </div>
</div>


<!-- toasts -->
<app-validation-toast #successToast></app-validation-toast>
<app-validation-toast #errorToast [persistent]="true" [actionText]="errorActionText" (action)="showErrorDetails()"></app-validation-toast>
<app-validation-toast #copyToast></app-validation-toast>

<!-- error details popup -->
<app-generic-popup
  [(visible)]="errorDetailsPopupVisible"
  i18n-title="@@errorDetails"
  title="Error details"
  [width]="520"
  [buttons]="errorPopupButtons"
>
  <pre class="error-details-text">{{ errorDetails }}</pre>
</app-generic-popup>

<!-- remove confirmation -->
<app-generic-popup
  [(visible)]="removeConfirmVisible"
  [title]="removeLinkTitle"
  [width]="420"
  [allowOutsideClick]="false"
  [buttons]="removePopupButtons">
  <div class="remove-popup-content">
    <p i18n="@@removeSandboxLinkConfirmQuestion">Are you sure you want to remove the sandbox folder link?</p>
    <app-validation-toast [inline]="true" [persistent]="true" state="Warning" [autoMessage]="msgRemoveWarning"></app-validation-toast>
  </div>
</app-generic-popup>
